import { render, staticRenderFns } from "./NotHome.vue?vue&type=template&id=6631690c&scoped=true"
import script from "./NotHome.vue?vue&type=script&lang=js"
export * from "./NotHome.vue?vue&type=script&lang=js"
import style0 from "./NotHome.vue?vue&type=style&index=0&id=6631690c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6631690c",
  null
  
)

export default component.exports